export const collect_point = {
    input: {
        name: '',
        placeholder: 'กรอกรหัสที่ {0}',
        required: '',
        too_short: 'กรุณากรอกรหัสให้ถูกต้อง',
        invalid: 'รหัสไม่ถูกต้อง',
        duplicate: 'รหัสซ้ำ',
        used: 'รหัสนี้ถูกใช้ไปเเล้ว',
    },
    add_input: 'เพิ่มช่องกรอกรหัส',
    scan_btn: 'สแกนรหัส',
    submit_btn: 'สะสมคะแนน',

    error_title: 'เกิดข้อผิดพลาด',
    error_message_scan: 'ไม่พบรหัส',
    error_message_empty: 'กรุณากรอกรหัสเพื่อรับคะแนน',
    error_message_block: 'ขออภัยคุณกรอกรหัสผิดหรือซ้ำเกิน 5 ครั้ง<br/>กรุณาส่งรหัสอีกครั้งในวันถัดไป',
    error_btnOk: 'ตกลง'
}